export var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export var CALENDAR_CONSTANTS = {
  valueType: "day",
  calendarType: "ISO 8601"
};
export var TOOLTIP_TEXTS = {
  navigate: "Navigate to",
  endOfRange: "End of Range"
};